function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 31,
  width: 2,
  height: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,14h11c0.6,0,1-0.4,1-1V2h30v3h2V1c0-0.6-0.4-1-1-1H13l0,0c-0.1,0-0.2,0-0.3,0.1h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2l-12,12 c-0.1,0.1-0.1,0.2-0.2,0.3v0.1C0.1,12.8,0,12.9,0,13l0,0v46c0,0.6,0.4,1,1,1h36v-2H2V14z M12,12H3.4l4.3-4.3L12,3.4L12,12L12,12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49,29c6.1,0,11-4.9,11-11S55.1,7,49,7s-11,4.9-11,11S42.9,29,49,29z M49,9c5,0,9,4,9,9s-4,9-9,9s-9-4-9-9S44,9,49,9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47,23h1v2h2v-2h1c1.2,0,2-0.8,2-2v-2c0-1.2-0.8-2-2-2h-4v-2h4v1h2v-1c0-1.2-0.8-2-2-2h-1v-2h-2v2h-1c-1.2,0-2,0.8-2,2v2 c0,1.2,0.8,2,2,2h4v2h-4v-1h-2v1C45,22.2,45.8,23,47,23z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59,36H41c-0.6,0-1,0.4-1,1v22c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1V37C60,36.4,59.6,36,59,36z M58,38v4H42v-4H58z M42,58 V44h16v14H42z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 45,
  y: 46,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 49,
  y: 46,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 53,
  y: 46,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 45,
  y: 50,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 49,
  y: 50,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 53,
  y: 50,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 45,
  y: 54,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 49,
  y: 54,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 53,
  y: 54,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 43,
  y: 39,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 46,
  y: 39,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 49,
  y: 39,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 39,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 55,
  y: 39,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 5,
  width: 6,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 10,
  width: 15,
  height: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.3,18.3l-3,3l1.4,1.4L9,21.4V35h2V21.4l1.3,1.3l1.4-1.4l-3-3C10.3,17.9,9.7,17.9,9.3,18.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.7,26.7l1.3-1.3V35h2v-9.6l1.3,1.3l1.4-1.4l-3-3c-0.4-0.4-1-0.4-1.4,0l-3,3L17.7,26.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31,19.4l1.3,1.3l1.4-1.4l-3-3c-0.4-0.4-1-0.4-1.4,0l-3,3l1.4,1.4l1.3-1.3V35h2L31,19.4L31,19.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 40,
  width: 15,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 45,
  width: 26,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 50,
  width: 26,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 26,
  y: 40,
  width: 4,
  height: 2
})));

function SvgComparisonReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonReport);
export default __webpack_public_path__ + "static/media/comparisonReport.406397b5.svg";
export { ForwardRef as ReactComponent };